import ApiService from "@/services/Api"
import { SuperlogicaPluginSettingsData } from "@/protocols/SuperlogicaPluginProtocol"

export type SuperlogicaCredentialsInput = {
	appToken: string
	accessToken: string
}

type CheckAuthCredentialsResponse = {
	pluginSettings: SuperlogicaPluginSettingsData
}

class SuperlogicaService {
	async checkAuthCredentials (): Promise<SuperlogicaPluginSettingsData> {
		const response = await ApiService.get<CheckAuthCredentialsResponse>("/plugin-settings/superlogica/auth")

		return response.data.pluginSettings
	}

	async revoke (): Promise<void> {
		await ApiService.post("/plugin-settings/superlogica/revoke")
	}
}

export default new SuperlogicaService()
